import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { ToastService } from '../../../../../@core/services/toast.service';
import { DialogComponent } from '../../../../../@core/components/ui/dialog/dialog.component';
import { MileStoneService } from '../../../../services/milestone.service';
import { IMilestone, MILESTONE_TYPE, STATUS_TYPE } from '../../../../../@core/models/model';
import { ButtonComponent } from "../../../../../@core/components/ui/button/button.component";
import { DeleteConfirmationComponent } from "../../../../../@core/components/ui/delete-confirmation/delete-confirmation.component";

@Component({
    selector: 'app-project-milestone',
    standalone: true,
    imports: [
        FormsModule,
        ButtonModule,
        DialogComponent,
        ButtonComponent,
        DeleteConfirmationComponent
    ],
    templateUrl: './project-milestone.component.html',
    styleUrls: ['./project-milestone.component.scss']
})
export class ProjectMilestoneComponent {
    milestones: IMilestone[] = [];

    showAddMilestoneDialog = false;
    showDeleteDialog = false;

    milestoneData: Partial<IMilestone> = { name: '' };

    editingMilestone: IMilestone | null = null;

    constructor(
        private milestoneService: MileStoneService,
        private toast: ToastService
    ) { }

    ngOnInit() {
        this.getMilestones();
    }

    getMilestones() {
        this.milestoneService.getMilestones(MILESTONE_TYPE.PROJECT).subscribe(res => {
            if (res.success) {
                this.milestones = res.data;
            } else {
                this.toast.error('Failed to fetch milestones.');
            }
        });
    }

    trackById(_idx: number, item: IMilestone) {
        return item._id;
    }

    // Open the add dialog
    closeMilestoneDialog() {
        this.showAddMilestoneDialog = false;
        this.milestoneData = { name: '' };
        this.editingMilestone = null;
    }

    // Called when user clicks "Add Milestone"
    saveMilestone() {
        const name = this.milestoneData.name?.trim();
        if (!name) {
            this.toast.error('Name cannot be empty.');
            return;
        }

        if (this.editingMilestone) {
            // EDIT
            this.milestoneService
                .updateMilestone(name, this.editingMilestone._id as string, MILESTONE_TYPE.PROJECT)
                .subscribe(res => {
                    if (res.success) {
                        const idx = this.milestones.findIndex(m => m._id === res.data._id);
                        if (idx > -1) this.milestones[idx] = res.data;
                        this.toast.success('Milestone updated.');
                        this.closeMilestoneDialog();
                    }
                });
        } else {
            // ADD
            this.milestoneService
                .addMilestone(name, MILESTONE_TYPE.PROJECT)
                .subscribe(res => {
                    if (res.success) {
                        this.milestones.push(res.data);
                        this.toast.success('Milestone added.');
                        this.closeMilestoneDialog();
                    }
                });
        }
    }

    // Populate dialog for editing
    openEditMilestoneDialog(m: IMilestone) {
        this.editingMilestone = m;
        this.milestoneData = { ...m };
        this.showAddMilestoneDialog = true;
    }

    // Delete flow
    openDeleteMilestoneDialog(m: IMilestone) {
        this.editingMilestone = m;
        this.showDeleteDialog = true;
    }

    closeDeleteMilestoneDialog() {
        this.showDeleteDialog = false;
        this.editingMilestone = null;
    }

    deleteMilestone() {
        if (!this.editingMilestone) return;
        this.milestoneService
            .deleteMilestone(this.editingMilestone._id as string)
            .subscribe(res => {
                if (res.success) {
                    this.milestones = this.milestones.filter(m => m._id !== this.editingMilestone!._id);
                    this.toast.success('Milestone deleted.');
                    this.closeDeleteMilestoneDialog();
                } else {
                    this.toast.error('Failed to delete milestone.');
                    this.closeDeleteMilestoneDialog();
                }
            });
    }

    get hasChanges(): boolean {
        if (!this.editingMilestone) return true;
        return this.milestoneData.name?.trim() !== this.editingMilestone?.name?.trim();
    }
}

